module.exports = __webpack_public_path__ + "static/media/logo-exposio.e0d7c12f.png";